export default __webpack_public_path__ + "js/components/common/unlock-button-font-pally/unlock_cta_golden_hover_bg-197f22372cbc202b5a1137fee5614699.png";